
    require('./gauge/GaugeSeries');
    require('./gauge/GaugeView');



//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/chart/gauge.js
// module id = 799
// module chunks = 0